export default {
  data () {
    return {
      currentLang: ''
    }
  },
  methods: {
    langChanged () {
      this.$store.state.currentRoute.lang = this.$store.state.lang
      this.$router.push(this.newRoute.replace('//', '/'))
    }
  },
  computed: {
    langStatus () {
      return this.currentLang !== this.lang ? 'langChanged' : 'langSame'
    }
  },
  created () {
    this.fetchData()
    this.currentLang = this.$route.params.lang || this.lang
    this.$route.params.lang = this.$store.state.lang
    this.$store.dispatch('setCurrentRoute', this.$route)
    this.$store.state.currentRoute.path = this.$store.state.currentRoute.path.replace('//', '/')
  },
  watch: {
    '$route': 'fetchData',
    'langStatus': 'langChanged',
    '$store.state.currentRoute.lang': 'langChanged'
  }
}
